<template>
	<el-select :multiple="multiple" v-model="values" :placeholder="placeholder" :clearable="clearable" @change="change">
		<div style="flex-direction: row;display: flex;padding:0 5px 5px 5px;" v-if="canAdd && data && data.akey">
			<el-input placeholder="请输入内容" v-model="name"></el-input>
			<add-button @click.native="ajaxAdd" label="添加" style="margin-left:5px;"></add-button>
		</div>
		<el-option
			v-for="item in list"
			:key="item[listValue]"
			:label="item[listLabel]"
			:value="item[listValue]"></el-option>
	</el-select>
</template>

<script>
export default {
	name: "TypeSelect",
	data() {
		return {
			list(){
				return []
			},
			values: '',
			name: '',
			default:'',
			loaded:false,
			params:null
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: [String, Number,Array],
			default: ''
		},
		data: {
			type: [Array, Object,String],
			default() {
				return null
			}
		},
		addUrl:{
			type:String,
			default:'/Type/add'
		},
		url:{
			type:String,
			default:'/Type/listAll'
		},
		options: {
			type: [Array, Object],
			default() {
				return null
			}
		},
		canAdd: {
			type: Boolean,
			default: true
		},
		clearable: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: '请选择'
		},
		listValue:{
			type:String,
			default:'id'
		},
		listLabel:{
			type:String,
			default:'name'
		}
	},
	created() {
		this.values = this.value;
		this.params = this.data ? this.data : null;
	},
	watch: {
		value(n, o) {
			this.values = n;
		},
		'data':{
			handler(n,o){
				this.params = n ? n : null;
			},
			deep:true,
			immediate:true
		}
	},
	mounted() {
		if (this.options) {
			this.list = this.options;
		} else {
			this.getList();
		}
	},
	methods: {
		getList() {
			let _this = this;
			
			let _datas = {};
			_datas.state = 1;
			
			_datas = this.params ? this.params : {}
			if(this.url === '/Area/listAll'){
			
			}else{
				_datas.orderBy = this.params && this.params.orderBy ? this.params.orderBy : 'sort';
				_datas.sortBy = this.params && this.params.sortBy ? this.params.sortBy : 'asc';
			}
			
			this.$http.httpPost({
				url: this.url,
				datas: _datas,
				success(res) {
					_this.list = res;
					for (let i=0;i< res.length;i++){
						if(res[i].is_default && res[i].is_default === 1){
							_this.default = res[i].id;
						}
					}
					
					if(!_this.value && !_this.loaded){
						_this.$emit("change", _this.default);
						_this.loaded = true;
					}
				}
			});
		},
		change(e) {
			this.$emit("change", e);
			this.$emit("changeCallback", e)
		},
		ajaxAdd() {
			let _this = this;
			
			this.$http.httpPost({
				url: this.addUrl,
				datas: {name: this.name, akey: this.data.akey},
				success(res) {
					console.log(res);
					_this.getList();
					_this.name = '';
				}
			});
		}
	}
}
</script>
